'use client';
import React from 'react';
import { createSvgIcon } from '@mui/material/utils';

export const ArrowDropDown = createSvgIcon(<path d="M7 10l5 5 5-5z" />, 'ArrowDropDown');
